/* unplugin-vue-components disabled */import { render } from "./UpgradeVoices.vue?vue&type=template&id=77ddce8c&scoped=true"
import script from "./UpgradeVoices.vue?vue&type=script&lang=js"
export * from "./UpgradeVoices.vue?vue&type=script&lang=js"

import "./UpgradeVoices.vue?vue&type=style&index=0&id=77ddce8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ddce8c"]])

export default __exports__